"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageUploaderTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _spacing = require("../../../constants/spacing");
const imageUploaderTheme = (0, _sdsThemeInternal.themed)({
  textColor: {
    default: (0, _designTokensReact.color)("color--text--neutral--strong"),
    invalid: {
      "lodestar-light": _designTokens.lodestarColors.buttonDestructive,
      //no token exists
      "ursa-light": (0, _designTokensReact.color)("color--text--error--default")
    },
    validHover: {
      "lodestar-light": _designTokens.lodestarColors.ctaLink,
      //no token exists
      "ursa-light": (0, _designTokensReact.color)("color--text--primary--stronger")
    }
  },
  border: {
    radius: {
      "lodestar-light": "2px",
      "ursa-light": "8px"
    },
    logoRadius: {
      "lodestar-light": "2px",
      "ursa-light": "4px"
    },
    color: {
      empty: {
        "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--default"),
        "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weak")
      },
      hover: {
        "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--strong"),
        "ursa-light": (0, _designTokensReact.color)("color--border--neutral--default")
      },
      invalid: {
        "lodestar-light": _designTokens.lodestarColors.buttonDestructive,
        //no token exists
        "ursa-light": (0, _designTokensReact.color)("color--border--error--default")
      },
      validHover: {
        "lodestar-light": _designTokens.lodestarColors.buttonPrimaryHover,
        //no token exists
        "ursa-light": (0, _designTokensReact.color)("color--border--primary--default")
      },
      disabled: {
        "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--strong"),
        "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weak")
      }
    }
  },
  backgroundColor: {
    hover: {
      "lodestar-light": "transparent",
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weakest")
    },
    invalid: (0, _designTokensReact.color)("color--background--spectrum-red--weakest"),
    validHover: (0, _designTokensReact.color)("color--background--primary--weakest"),
    disabled: {
      "lodestar-light": "transparent",
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weakest")
    }
  },
  buttonGroup: {
    marginTop: {
      "lodestar-light": _spacing.sizes.xxSmall,
      "ursa-light": _spacing.sizes.small
    }
  },
  image: {
    radius: {
      "lodestar-light": "4px",
      "ursa-light": "8px"
    }
  },
  padding: {
    image: {
      "lodestar-light": `${_spacing.sizes.xLarge}px 0px`,
      "ursa-light": "36px 0px 24px"
    },
    logo: {
      "lodestar-light": `${_spacing.sizes.small}px 0px`,
      "ursa-light": `${_spacing.sizes.small}px 0px`
    }
  },
  dropSpan: {
    variant: {
      "lodestar-light": "bodyText",
      "ursa-light": "TT-Norms-Pro--14px--700w"
    },
    hoverVariant: {
      "lodestar-light": "titlesEmphasis",
      "ursa-light": "TT-Norms-Pro--14px--700w"
    },
    marginTop: {
      "lodestar-light": _spacing.sizes.small,
      "ursa-light": 0
    }
  },
  dropZoneHeight: {
    image: {
      "lodestar-light": 160,
      "ursa-light": 192
    },
    logo: {
      "lodestar-light": 40,
      "ursa-light": 72
    },
    logoLarge: {
      "lodestar-light": 52,
      "ursa-light": 72
    }
  },
  browseButton: {
    height: {
      "lodestar-light": 32,
      "ursa-light": 24
    },
    fontSize: {
      "lodestar-light": 13,
      "ursa-light": 14
    },
    fontWeight: {
      "lodestar-light": "normal",
      "ursa-light": "default"
    }
  },
  changeButton: {
    "lodestar-light": "borderless",
    "ursa-light": "secondary"
  },
  revertButton: {
    appearance: {
      "lodestar-light": "borderless",
      "ursa-light": "secondary"
    },
    fontWeight: {
      "lodestar-light": "normal",
      "ursa-light": "default"
    }
  },
  errorSpan: {
    color: (0, _designTokensReact.color)("color--border--error--default")
  }
});
exports.imageUploaderTheme = imageUploaderTheme;
//# sourceMappingURL=imageUploaderTheme.js.map